/*
 * AUTHENTICA: Tabby promo renderer — 2026-08-06.
 *
 * Drives every [data-tabby-promo] element on the page: product pages and cart.
 *
 * This lives in an asset file rather than inline in the snippet on purpose.
 * The cart re-renders itself with `elementToReplace.innerHTML = ...` (see
 * assets/cart.js renderContents), and scripts inserted via innerHTML never
 * execute. An inline script would work on first paint and then go dead the
 * moment anyone changed a quantity.
 *
 * Config arrives on the element's data attributes so the Liquid stays dumb.
 */
(function () {
  if (window.__tabbyPromoInit) return;
  window.__tabbyPromoInit = true;

  var SRC = 'https://checkout.tabby.ai/tabby-promo.js';
  var state = 'idle'; // idle | loading | ready | failed
  var waiting = [];

  function withTabby(fn) {
    if (state === 'ready') return fn();
    if (state === 'failed') return;
    waiting.push(fn);
    if (state === 'loading') return;
    state = 'loading';
    var s = document.createElement('script');
    s.src = SRC;
    s.async = true;
    s.onload = function () {
      state = 'ready';
      waiting.splice(0).forEach(function (f) { f(); });
    };
    s.onerror = function () {
      state = 'failed';
      waiting.length = 0;
      hideAll();
    };
    document.head.appendChild(s);
  }

  function hideAll() {
    each(document.querySelectorAll('[data-tabby-promo]'), function (el) {
      el.style.display = 'none';
    });
  }

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function amount(el, minor) {
    var units = parseInt(el.dataset.minorUnits, 10) || 100;
    var n = Number(minor);
    if (!isFinite(n) || n <= 0) return null;
    return { value: n / units, dp: units === 1000 ? 3 : 2 };
  }

  function render(el, minor) {
    var noPrice = el.dataset.noPrice === 'true';
    var amt = null;

    if (!noPrice) {
      amt = amount(el, minor != null ? minor : el.dataset.price);
      if (!amt) { el.style.display = 'none'; return; }
    }

    withTabby(function () {
      if (!document.body.contains(el)) return;
      el.style.display = '';
      el.innerHTML = '';
      var cfg = {
        selector: '#' + el.id,
        lang: el.dataset.lang,
        publicKey: el.dataset.publicKey,
        merchantCode: el.dataset.merchantCode
      };
      if (!noPrice) {
        cfg.currency = el.dataset.currency;
        cfg.price = amt.value.toFixed(amt.dp);
        cfg.installmentsCount = 4;
      }
      try {
        new window.TabbyPromo(cfg);
      } catch (e) {
        // A promo widget must never break a buy box or a cart.
        el.style.display = 'none';
      }
    });
  }

  function renderScope(context, minor) {
    each(document.querySelectorAll('[data-tabby-promo][data-context="' + context + '"]'),
      function (el) { render(el, minor); });
  }

  function boot() {
    each(document.querySelectorAll('[data-tabby-promo]'), function (el) { render(el); });
  }

  // --- product: the theme's variant event carries no price, only an id -------
  document.addEventListener('product:variant-change', function (event) {
    var d = event.detail || {};
    each(document.querySelectorAll('[data-tabby-promo][data-context="product"]'), function (el) {
      if (d.sectionId && el.dataset.sectionId && d.sectionId !== el.dataset.sectionId) return;
      if (!d.variant || !d.variant.id || !d.variant.available) { el.style.display = 'none'; return; }
      var prices = {};
      try { prices = JSON.parse(el.dataset.prices || '{}'); } catch (e) {}
      render(el, prices[d.variant.id]);
    });
  });

  // --- cart -----------------------------------------------------------------
  // These fire AFTER the cart markup has been replaced, so the fresh element
  // already carries the new total in data-price. Prefer the event's cart object
  // when it is there, fall back to the re-rendered attribute when it is not.
  function onCartChange(event) {
    var cart = (event.detail && (event.detail.cart || event.detail)) || {};
    renderScope('cart', typeof cart.total_price === 'number' ? cart.total_price : null);
  }
  ['line-item:change:end', 'cart:refresh', 'cart:item-added'].forEach(function (name) {
    document.addEventListener(name, onCartChange);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
